// extracted by mini-css-extract-plugin
module.exports = {"image_table":"index_image_table__1keHP"};